/**
 * Calibrated video processing-time estimate for the admin progress UI.
 *
 * expected = duration_seconds × 0.16
 * displayed (UI) = expected × 1.20
 *
 * Do not derive estimates from file size.
 */

/** Steady-state processing factor from V01–V13 STT-success calibration. */
export const VIDEO_PROCESSING_FACTOR = 0.16;

/** Agreed UI buffer on top of expected processing time. */
export const VIDEO_PROCESSING_UI_BUFFER = 1.2;

export function expectedProcessingSeconds(durationSeconds: number): number {
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
    return 0;
  }
  return durationSeconds * VIDEO_PROCESSING_FACTOR;
}

/** UI-facing estimate (expected × 1.20). Not a live ETA. */
export function displayedProcessingEstimateSeconds(
  durationSeconds: number
): number {
  return expectedProcessingSeconds(durationSeconds) * VIDEO_PROCESSING_UI_BUFFER;
}

/**
 * Format a duration in seconds for progress UI (e.g. "45 sec", "4 min 13 sec").
 */
export function formatProcessingDurationLabel(totalSeconds: number): string {
  if (!Number.isFinite(totalSeconds) || totalSeconds < 0) {
    return "0 sec";
  }
  const rounded = Math.round(totalSeconds);
  if (rounded < 60) {
    return `${rounded} sec`;
  }
  const minutes = Math.floor(rounded / 60);
  const seconds = rounded % 60;
  if (seconds === 0) {
    return `${minutes} min`;
  }
  return `${minutes} min ${seconds} sec`;
}
